// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

import { createVuetify } from 'vuetify'

import { BeigeTheme as beige, GreyTheme as grey, LightTheme as light, MidnightTheme as midnight } from '@/plugins/theme'

const vuetify = createVuetify({
  defaults: {
    VAppBar: {
      elevation: 2,
    },
    VBtn: {
      variant: 'elevated',
    },
    VCard: {
      elevation: 1,
    },
    VFooter: {
      elevation: 0,
    },
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      beige,
      grey,
      light,
      midnight,
    },
  },
})

export { vuetify }
